var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !!_vm.type
        ? _c("el-button", {
            attrs: { type: "warning", circle: "", icon: "el-icon-plus" },
            on: { click: _vm.handleDialog },
          })
        : _c(
            "el-button",
            {
              attrs: { type: "primary", size: "mini" },
              on: { click: _vm.handleDialog },
            },
            [_vm._v("設定")]
          ),
      _c(
        "el-dialog",
        {
          attrs: {
            top: "2%",
            width: "80%",
            visible: _vm.dialogFormVisible,
            title: "活動推播設定",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
            closed: _vm.onDialogClosed,
          },
        },
        [
          _c(
            "div",
            { staticClass: "notice" },
            [
              _c(
                "el-form",
                {
                  ref: "formRef",
                  staticClass: "notice-form",
                  attrs: {
                    model: _vm.pushNotification,
                    rules: _vm.pushNotificationRules,
                    size: "small",
                    "label-position": "left",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "推播對象", prop: "pushType" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          staticStyle: { display: "flex" },
                          on: { change: _vm.handleChangePushType },
                          model: {
                            value: _vm.pushNotification.pushType,
                            callback: function ($$v) {
                              _vm.$set(_vm.pushNotification, "pushType", $$v)
                            },
                            expression: "pushNotification.pushType",
                          },
                        },
                        [
                          _c("el-radio-button", { attrs: { label: "all" } }, [
                            _vm._v("所有旅行團"),
                          ]),
                          _c(
                            "el-radio-button",
                            { attrs: { label: "special" } },
                            [_vm._v("指定旅行團")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "notice-form__select",
                              attrs: {
                                multiple: "",
                                placeholder: "請選擇旅行團",
                                disabled:
                                  _vm.pushNotification.pushType === "all",
                              },
                              model: {
                                value: _vm.pushNotification.travelIDs,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.pushNotification,
                                    "travelIDs",
                                    $$v
                                  )
                                },
                                expression: "pushNotification.travelIDs",
                              },
                            },
                            _vm._l(_vm.groupOptions, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: {
                                  label: item.travelName,
                                  value: item.id,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "推播標題", prop: "subject" } },
                    [
                      _c("el-input", {
                        attrs: {
                          name: "subject",
                          "show-word-limit": "",
                          maxlength: "10",
                          placeholder: "請輸入推播標題（10字內）",
                        },
                        model: {
                          value: _vm.pushNotification.subject,
                          callback: function ($$v) {
                            _vm.$set(_vm.pushNotification, "subject", $$v)
                          },
                          expression: "pushNotification.subject",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "推播內文", prop: "content" } },
                    [
                      _c("el-input", {
                        attrs: {
                          name: "content",
                          type: "textarea",
                          "show-word-limit": "",
                          resize: "none",
                          autosize: { minRows: 2, maxRows: 4 },
                          placeholder: "請輸入推播內文（30字內）",
                          maxlength: "30",
                        },
                        model: {
                          value: _vm.pushNotification.content,
                          callback: function ($$v) {
                            _vm.$set(_vm.pushNotification, "content", $$v)
                          },
                          expression: "pushNotification.content",
                        },
                      }),
                    ],
                    1
                  ),
                  !!_vm.type
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "自訂連結", prop: "link" } },
                        [
                          _c("el-input", {
                            attrs: {
                              name: "link",
                              placeholder: "請輸入自訂連結",
                            },
                            model: {
                              value: _vm.pushNotification.link,
                              callback: function ($$v) {
                                _vm.$set(_vm.pushNotification, "link", $$v)
                              },
                              expression: "pushNotification.link",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "notice-footer" },
                    [
                      _c(
                        "el-button",
                        {
                          staticStyle: { color: "#4b4b4b" },
                          attrs: { type: "warning" },
                          on: { click: _vm.handleSubmit },
                        },
                        [_vm._v(" 發 送 ")]
                      ),
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function ($event) {
                              _vm.dialogFormVisible = false
                            },
                          },
                        },
                        [_vm._v(" 取 消 ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              !_vm.type
                ? _c("div", { staticClass: "notice-preview" }, [
                    _c("span", { staticClass: "notice-preview__title" }, [
                      _vm._v("預覽"),
                    ]),
                    _c("div", { staticClass: "coupon-detail" }, [
                      _c("div", { staticClass: "coupon-banner" }, [
                        _c("img", {
                          staticStyle: { width: "100%", height: "100%" },
                          attrs: {
                            src: _vm.data.fileInfo[0].files[0].url,
                            alt: _vm.data.fileInfo[0].files[0].fileName,
                          },
                        }),
                      ]),
                      _c("div", {
                        staticStyle: {
                          width: "100%",
                          height: "1px",
                          background: "#e5e5e5",
                        },
                      }),
                      _c(
                        "div",
                        { ref: "couponMain", staticClass: "coupon-main" },
                        [
                          _c("div", { staticClass: "coupon-header" }, [
                            _c("div", [
                              _c("h1", { staticClass: "coupon-title" }, [
                                _vm._v(_vm._s(_vm.data.couponName)),
                              ]),
                            ]),
                            _c("div", { staticClass: "coupon-action" }, [
                              _c("div", { staticClass: "icon-container" }, [
                                _c(
                                  "svg",
                                  {
                                    attrs: {
                                      fill: "#000000",
                                      version: "1.1",
                                      id: "Capa_1",
                                      xmlns: "http://www.w3.org/2000/svg",
                                      "xmlns:xlink":
                                        "http://www.w3.org/1999/xlink",
                                      viewBox: "0 0 296.528 296.528",
                                      "xml:space": "preserve",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("path", {
                                        attrs: {
                                          d: "M295.838,115.347l0.003-0.001l-0.092-0.76c-0.001-0.013-0.002-0.023-0.004-0.036c-0.001-0.011-0.002-0.021-0.004-0.032\n                                      l-0.344-2.858c-0.069-0.574-0.148-1.228-0.238-1.974l-0.072-0.594l-0.147,0.018c-3.617-20.571-13.553-40.093-28.942-56.762\n                                      c-15.317-16.589-35.217-29.687-57.548-37.878c-19.133-7.018-39.434-10.577-60.337-10.577c-28.22,0-55.627,6.637-79.257,19.193\n                                      C23.289,47.297-3.585,91.799,0.387,136.461c2.056,23.111,11.11,45.11,26.184,63.621c14.188,17.423,33.381,31.483,55.503,40.66\n                                      c13.602,5.642,27.051,8.301,41.291,11.116l1.667,0.33c3.921,0.776,4.975,1.842,5.247,2.264c0.503,0.784,0.24,2.329,0.038,3.18\n                                      c-0.186,0.785-0.378,1.568-0.57,2.352c-1.529,6.235-3.11,12.683-1.868,19.792c1.428,8.172,6.531,12.859,14.001,12.86\n                                      c0.001,0,0.001,0,0.002,0c8.035,0,17.18-5.39,23.231-8.956l0.808-0.475c14.436-8.478,28.036-18.041,38.271-25.425\n                                      c22.397-16.159,47.783-34.475,66.815-58.17C290.172,175.745,299.2,145.078,295.838,115.347z M92.343,160.561H66.761\n                                      c-3.866,0-7-3.134-7-7V99.865c0-3.866,3.134-7,7-7c3.866,0,7,3.134,7,7v46.696h18.581c3.866,0,7,3.134,7,7\n                                      C99.343,157.427,96.209,160.561,92.343,160.561z M119.03,153.371c0,3.866-3.134,7-7,7c-3.866,0-7-3.134-7-7V99.675\n                                      c0-3.866,3.134-7,7-7c3.866,0,7,3.134,7,7V153.371z M182.304,153.371c0,3.033-1.953,5.721-4.838,6.658\n                                      c-0.712,0.231-1.441,0.343-2.161,0.343c-2.199,0-4.323-1.039-5.666-2.888l-25.207-34.717v30.605c0,3.866-3.134,7-7,7\n                                      c-3.866,0-7-3.134-7-7v-52.16c0-3.033,1.953-5.721,4.838-6.658c2.886-0.936,6.045,0.09,7.827,2.545l25.207,34.717V99.675\n                                      c0-3.866,3.134-7,7-7c3.866,0,7,3.134,7,7V153.371z M233.311,159.269h-34.645c-3.866,0-7-3.134-7-7v-26.847V98.573\n                                      c0-3.866,3.134-7,7-7h33.57c3.866,0,7,3.134,7,7s-3.134,7-7,7h-26.57v12.849h21.562c3.866,0,7,3.134,7,7c0,3.866-3.134,7-7,7\n                                      h-21.562v12.847h27.645c3.866,0,7,3.134,7,7S237.177,159.269,233.311,159.269z",
                                        },
                                      }),
                                    ]),
                                  ]
                                ),
                              ]),
                              _c("div", { staticClass: "icon-container" }, [
                                _c(
                                  "svg",
                                  {
                                    staticClass:
                                      "coupon-icon coupon-icon__share",
                                    attrs: {
                                      width: "24",
                                      height: "25",
                                      viewBox: "0 0 24 25",
                                      fill: "none",
                                      xmlns: "http://www.w3.org/2000/svg",
                                    },
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        d: "M18 16.58C17.24 16.58 16.56 16.88 16.04 17.35L8.91 13.2C8.96 12.97 9 12.74 9 12.5C9 12.26 8.96 12.03 8.91 11.8L15.96 7.69C16.5 8.19 17.21 8.5 18 8.5C18.7956 8.5 19.5587 8.18393 20.1213 7.62132C20.6839 7.05871 21 6.29565 21 5.5C21 4.70435 20.6839 3.94129 20.1213 3.37868C19.5587 2.81607 18.7956 2.5 18 2.5C17.2044 2.5 16.4413 2.81607 15.8787 3.37868C15.3161 3.94129 15 4.70435 15 5.5C15 5.74 15.04 5.97 15.09 6.2L8.04 10.31C7.5 9.81 6.79 9.5 6 9.5C5.20435 9.5 4.44129 9.81607 3.87868 10.3787C3.31607 10.9413 3 11.7044 3 12.5C3 13.2956 3.31607 14.0587 3.87868 14.6213C4.44129 15.1839 5.20435 15.5 6 15.5C6.79 15.5 7.5 15.19 8.04 14.69L15.16 18.84C15.11 19.05 15.08 19.27 15.08 19.5C15.08 21.11 16.39 22.41 18 22.41C19.61 22.41 20.92 21.11 20.92 19.5C20.92 18.7256 20.6124 17.9829 20.0648 17.4352C19.5171 16.8876 18.7744 16.58 18 16.58Z",
                                        fill: "black",
                                      },
                                    }),
                                  ]
                                ),
                              ]),
                              _c("div", { staticClass: "icon-container" }, [
                                _c(
                                  "svg",
                                  {
                                    staticClass: "coupon-icon coupon-icon__web",
                                    attrs: {
                                      width: "24",
                                      height: "25",
                                      viewBox: "0 0 24 25",
                                      fill: "none",
                                      xmlns: "http://www.w3.org/2000/svg",
                                    },
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        d: "M17.9 17.89C17.64 17.09 16.89 16.5 16 16.5H15V13.5C15 13.2348 14.8946 12.9804 14.7071 12.7929C14.5196 12.6054 14.2652 12.5 14 12.5H8V10.5H10C10.2652 10.5 10.5196 10.3946 10.7071 10.2071C10.8946 10.0196 11 9.76522 11 9.5V7.5H13C13.5304 7.5 14.0391 7.28929 14.4142 6.91421C14.7893 6.53914 15 6.03043 15 5.5V5.09C17.93 6.27 20 9.14 20 12.5C20 14.58 19.2 16.47 17.9 17.89ZM11 20.43C7.05 19.94 4 16.58 4 12.5C4 11.88 4.08 11.28 4.21 10.71L9 15.5V16.5C9 17.0304 9.21071 17.5391 9.58579 17.9142C9.96086 18.2893 10.4696 18.5 11 18.5M12 2.5C10.6868 2.5 9.38642 2.75866 8.17317 3.2612C6.95991 3.76375 5.85752 4.50035 4.92893 5.42893C3.05357 7.3043 2 9.84784 2 12.5C2 15.1522 3.05357 17.6957 4.92893 19.5711C5.85752 20.4997 6.95991 21.2362 8.17317 21.7388C9.38642 22.2413 10.6868 22.5 12 22.5C14.6522 22.5 17.1957 21.4464 19.0711 19.5711C20.9464 17.6957 22 15.1522 22 12.5C22 11.1868 21.7413 9.88642 21.2388 8.67317C20.7362 7.45991 19.9997 6.35752 19.0711 5.42893C18.1425 4.50035 17.0401 3.76375 15.8268 3.2612C14.6136 2.75866 13.3132 2.5 12 2.5Z",
                                        fill: "black",
                                      },
                                    }),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("div", { attrs: { id: "couponDescs" } }),
                          _c(
                            "div",
                            {
                              staticClass: "coupon-content",
                              staticStyle: { "max-width": "100%" },
                            },
                            [
                              _c("div", { staticClass: "content-header" }, [
                                _c("h3", [_vm._v("優惠內容")]),
                                _c(
                                  "h3",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !!_vm.agencyTel,
                                        expression: "!!agencyTel",
                                      },
                                    ],
                                    staticClass: "content-header",
                                  },
                                  [
                                    _c(
                                      "svg",
                                      {
                                        staticClass:
                                          "coupon-icon coupon-icon__phone",
                                        attrs: {
                                          width: "24",
                                          height: "24",
                                          viewBox: "0 0 24 24",
                                          fill: "none",
                                          xmlns: "http://www.w3.org/2000/svg",
                                        },
                                      },
                                      [
                                        _c("path", {
                                          attrs: {
                                            d: "M20 15.5C18.8 15.5 17.5 15.3 16.4 14.9C16.3 14.9 16.2 14.9 16.1 14.9C15.8 14.9 15.6 15 15.4 15.2L13.2 17.4C10.4 15.9 8 13.6 6.6 10.8L8.8 8.6C9.1 8.3 9.2 7.9 9 7.6C8.7 6.5 8.5 5.2 8.5 4C8.5 3.5 8 3 7.5 3H4C3.5 3 3 3.5 3 4C3 13.4 10.6 21 20 21C20.5 21 21 20.5 21 20V16.5C21 16 20.5 15.5 20 15.5ZM5 5H6.5C6.6 5.9 6.8 6.8 7 7.6L5.8 8.8C5.4 7.6 5.1 6.3 5 5ZM19 19C17.7 18.9 16.4 18.6 15.2 18.2L16.4 17C17.2 17.2 18.1 17.4 19 17.4V19Z",
                                            fill: "black",
                                          },
                                        }),
                                        _c("path", {
                                          attrs: {
                                            d: "M5 5H6.5C6.6 5.9 6.8 6.8 7 7.6L5.8 8.8C5.4 7.6 5.1 6.3 5 5Z",
                                            fill: "none",
                                          },
                                        }),
                                        _c("path", {
                                          attrs: {
                                            d: "M19 19C17.7 18.9 16.4 18.6 15.2 18.2L16.4 17C17.2 17.2 18.1 17.4 19 17.4V19Z",
                                            fill: "none",
                                          },
                                        }),
                                      ]
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "content-header__phone" },
                                      [_vm._v(_vm._s(_vm.agencyTel))]
                                    ),
                                  ]
                                ),
                              ]),
                              _c("p", [_vm._v(_vm._s(_vm.data.description))]),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ])
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }